module.exports = __webpack_public_path__ + "img/textscreen1.87c3aae4.png";